import clsx from 'clsx';
import { Radio as BaseRadio } from '@headlessui/react';

export enum RadioColors {
  Purple = 'Purple',
  Blue = 'Blue',
  Gray = 'Gray',
  Green = 'Green',
  Red = 'Red',
}

type RadioProps = {
  value?: any;
  disabled?: boolean;
  checked?: boolean;
  color?: RadioColors;
};

const ColorScheme = {
  [RadioColors.Purple]: {
    checked: ['border-purple-900', 'text-white'],
    indeterminate: ['bg-purple-500', 'border-purple-500', 'text-white'],
    unchecked: ['border-gray-300', 'text-opacity-0'],
    disabled: ['bg-gray-300', 'text-gray-600', 'border-gray-300'],
  },
  [RadioColors.Red]: {
    checked: ['border-red-500', 'text-white'],
    indeterminate: ['bg-red-300', 'border-red-300', 'text-white'],
    unchecked: ['border-gray-300', 'text-opacity-0'],
    disabled: ['text-gray-600', 'bg-gray-300', 'border-gray-300'],
  },
  [RadioColors.Blue]: {
    checked: ['border-blue-600', 'text-white'],
    indeterminate: ['bg-blue-400', 'border-blue-400', 'text-white'],
    unchecked: ['border-gray-300', 'text-opacity-0'],
    disabled: ['bg-gray-300', 'text-gray-600', 'border-gray-300'],
  },
  [RadioColors.Gray]: {
    checked: ['border-gray-900', 'text-white'],
    indeterminate: ['bg-gray-700', 'border-gray-700', 'text-white'],
    unchecked: ['border-gray-300', 'text-opacity-0'],
    disabled: ['bg-gray-300', 'text-gray-600', 'border-gray-300'],
  },
  [RadioColors.Green]: {
    checked: ['border-green-500', 'text-white'],
    indeterminate: ['bg-green-500', 'border-green-500', 'text-white'],
    unchecked: ['border-gray-300', 'text-opacity-0'],
    disabled: ['bg-gray-300', 'text-gray-600', 'border-gray-300'],
  },
};

const IndicatorColor = {
  [RadioColors.Purple]: 'bg-purple-900',
  [RadioColors.Red]: 'bg-red-500',
  [RadioColors.Blue]: 'bg-blue-600',
  [RadioColors.Gray]: 'bg-gray-900',
  [RadioColors.Green]: 'bg-green-500',
};

export const Radio = ({
  color = RadioColors.Gray,
  value,
  checked,
  disabled,
}: RadioProps) => {
  return (
    <BaseRadio value={value} className="bg-white rounded-lg">
      <span
        className={clsx(
          'group flex items-center justify-center rounded-full w-6 h-6 border-2 border-gray-900 text-white relative',
          ColorScheme[color].unchecked,
          !disabled && checked && ColorScheme[color].checked,
          disabled && ColorScheme[color].disabled,
          !disabled && 'cursor-pointer',
        )}
      >
        {checked && (
          <div
            className={clsx('w-3 h-3 rounded-lg', IndicatorColor[color])}
          ></div>
        )}
      </span>
    </BaseRadio>
  );
};
